import { useLocation, useNavigate } from "react-router";
import { useUrlProvider } from "../useUrlProvider";
import { CreateLegalEntityReturnType, LegalEntityScope } from "./legalEntities/LegalEntities.types";

// Returns undefined when the caller has no return context, which is what switches the detour off.
export function useCreateAndNavigate(returnName?: string, returnType?: CreateLegalEntityReturnType) {
    const location = useLocation();
    const navigate = useNavigate();
    const { getLegalEntityEditUrl } = useUrlProvider();

    if (!returnName || !returnType) {
        return undefined;
    }

    return (legalEntityId: string, legalEntityScope: LegalEntityScope) => {
        const returnParams = new URLSearchParams({
            returnUrl: location.pathname + location.search + location.hash,
            returnName: returnName,
            returnType: returnType,
            // Keeps the stepper from marking unvisited steps as failing validation while the entity is still being created.
            create: "true",
        });

        navigate(getLegalEntityEditUrl(legalEntityScope, legalEntityId, returnParams.toString()));
    };
}
